import React from "react";
import { Helmet } from "react-helmet-async";

import "./Sponsors.scss";
import sponsors from "../../components/SponsorsList_2025.jsx";
import sponsorshipPacket from "./MFly_SponsorshipPacket_25_26.pdf";

const tierBenefits = {
  "First Class": {
    price: "$5,000+",
    benefits: [
      { name: "Resume Book", included: true },
      { name: "Design Review", included: true },
      { name: "Logo on Website", included: true },
      { name: "Logo on T-Shirt and Planes", included: true },
      { name: "Social Media Shoutouts", included: true },
      { name: "Prioritized & Larger Logo Placement", included: true },
      { name: "Private Meetings with Team", included: true },
      { name: "Workspace Tour", included: true },
    ],
  },
  "Business Class": {
    price: "$2,500-$4,999",
    benefits: [
      { name: "Resume Book", included: true },
      { name: "Design Review", included: true },
      { name: "Logo on Website", included: true },
      { name: "Logo on T-Shirt and Planes", included: true },
      { name: "Social Media Shoutouts", included: true },
      { name: "Prioritized & Larger Logo Placement", included: false },
      { name: "Private Meetings with Team", included: false },
      { name: "Workspace Tour", included: false },
    ],
  },
  "Coach Class": {
    price: "$500-$2,499",
    benefits: [
      { name: "Resume Book", included: true },
      { name: "Design Review", included: true },
      { name: "Logo on Website", included: true },
      { name: "Logo on T-Shirt and Planes", included: true },
      { name: "Social Media Shoutouts", included: false },
      { name: "Prioritized & Larger Logo Placement", included: false },
      { name: "Private Meetings with Team", included: false },
      { name: "Workspace Tour", included: false },
    ],
  },
};

export default function Sponsors() {
  const getTierClass = (tier) => {
    return tier.toLowerCase().replace(/\s+/g, "-");
  };

  const getScrollDuration = (count) => {
    return Math.max(20, count * 6);
  };

  const getScrollMaxWidth = (count) => {
    const perItem = 260;
    return Math.min(1100, Math.max(520, count * perItem));
  };

  return (
    <>
      <Helmet>
        <title>Sponsors | M-Fly</title>
      </Helmet>
      <div className="Sponsors">
        <div className="white-div">
          <h1 className="text-center">Sponsorships</h1>
          <p className="description-center">
            M-Fly relies on donations and corporate sponsorships to fund all of
            our operations throughout the school year. If you are interested in
            donating to our team, use the button below, and you'll be redirected
            to our Giving Blueday profile. Your generosity will assist us in
            expenses related to purchasing materials for aircraft fabrication,
            designing and testing our prototypes, funding competition
            registration and travel, and hosting community outreach events.
            <br />
            <br />
            If your company is unable to provide monetary gifts but still wishes
            to contribute, we highly value material donations that can aid our
            project. Examples include carbon fiber, routed molds, and hardware
            components. We welcome the opportunity to discuss and explore how
            your material donations can positively impact our endeavors.
            <br />
            <br />
            All gifts to M-Fly are accepted through the University of Michigan
            and a tax acknowledgement letter is issued by the University as a
            501(c) 3 non-profit organization. If you have any further questions
            regarding gifts, please do not hesitate to contact us.
          </p>
          <div className="button-group">
            <button
              onClick={() =>
                window.location.href =
                  "https://leadersandbest.umich.edu/find/#!/give/basket/fund/937675"
              }
              className="action-btn donate-btn"
            >
              DONATE
            </button>
            <button
              onClick={() => {
                const link = document.createElement("a");
                link.href = sponsorshipPacket;
                link.download = "MFly_SponsorshipPacket_25_26.pdf";
                link.click();
              }}
              className="action-btn packet-btn"
            >
              SPONSORSHIP PACKET
            </button>
          </div>
        </div>

        <div className="white-div">
          <h2 className="text-center">Benefits</h2>
          <div className="benefits-table-container">
            <table className="benefits-table">
              <thead>
                <tr>
                  <th>Benefits</th>
                  {Object.keys(tierBenefits).map((tier) => (
                    <th key={tier}>
                      <div className="tier-header">
                        <div className="tier-name">{tier}</div>
                        <div className="tier-price">
                          {tierBenefits[tier].price}
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tierBenefits["First Class"].benefits.map((benefit, idx) => (
                  <tr key={idx}>
                    <td className="benefit-name">{benefit.name}</td>
                    {Object.keys(tierBenefits).map((tier) => (
                      <td key={tier} className="benefit-cell">
                        {tierBenefits[tier].benefits[idx].included ? (
                          <span className="checkmark">✓</span>
                        ) : (
                          <span className="x-mark"></span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {sponsors.map(({ tier, list }) => (
          <div className="white-div" key={tier}>
            <h2 className="blue-div">{tier}</h2>
            {list.length > 0 && (
              (() => {
                const isScrolling = list.length >= 2;
                const items = list.map(({ name, image, url }, idx) => (
                  <a
                    key={`${name}-${idx}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`sponsor-item tier-${getTierClass(tier)}`}
                  >
                    <img src={image} alt={name} />
                  </a>
                ));

                const cloneItems = list.map(({ name, image, url }, idx) => (
                  <a
                    key={`${name}-clone-${idx}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`sponsor-item tier-${getTierClass(tier)}`}
                    aria-hidden={true}
                    tabIndex={-1}
                  >
                    <img src={image} alt={name} />
                  </a>
                ));

                return (
              <div
                className={`sponsors-scroll-container ${
                  isScrolling ? "is-scrolling" : "is-static"
                }`}
                style={{
                  "--scroll-duration": `${getScrollDuration(list.length)}s`,
                  maxWidth: `${getScrollMaxWidth(list.length)}px`,
                }}
              >
                <div className="sponsors-track">
                  <div className="sponsors-group">{items}</div>
                  {isScrolling && (
                    <div className="sponsors-group" aria-hidden={true}>
                      {cloneItems}
                    </div>
                  )}
                </div>
              </div>
                );
              })()
            )}
          </div>
        ))}
      </div>
    </>
  );
}
